/* ==========================================================================
   SHIRTPLUS — PREMIUM PDP  (vanilla JS, no jQuery, no theme deps)
   - <sp-pdp-product> custom element: color switching, size/qty matrix,
     multi-line add-to-cart, live totals + volume-discount highlight,
     branding upload prep.
   - Generic helpers: accordion, modal, sticky CTA proxy.
   Integrates with the Impact theme via `cart:refresh` + `variant:add` events
   and `window.Shopify.routes.root`.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__spPdpLoaded) return;
  window.__spPdpLoaded = true;

  function formatMoney(cents) {
    var fmt = (window.themeVariables &&
               window.themeVariables.settings &&
               window.themeVariables.settings.moneyFormat) || '{{amount}} €';
    fmt = fmt.replace(/<[^>]*>/g, '');
    cents = Number(cents) || 0;

    function thousands(num, sep, decimals, decSep) {
      var value = (cents / 100).toFixed(decimals);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return decimals ? parts.join(decSep) : parts[0];
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':                                 return thousands(cents, ',', 2, '.');
        case 'amount_no_decimals':                     return thousands(cents, ',', 0, '.');
        case 'amount_with_comma_separator':            return thousands(cents, '.', 2, ',');
        case 'amount_no_decimals_with_comma_separator':return thousands(cents, '.', 0, ',');
        case 'amount_with_space_separator':            return thousands(cents, ' ', 2, ',');
        case 'amount_with_apostrophe_separator':       return thousands(cents, "'", 2, '.');
        default:                                       return thousands(cents, '.', 2, ',');
      }
    });
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function toast(msg, isError) {
    var el = document.createElement('div');
    el.className = 'sp-pdp-toast';
    el.textContent = msg;
    if (isError) el.style.background = '#b42318';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------------
     SP-800-041 — LOGO-SLOT-ERMITTLUNG FUER DAS PREMIUM ADD-TO-CART MODAL

     Fachlich identisch zur freigegebenen Warenkorb-Logik aus SP-800-040
     (snippets/sp-avis-logo-index.liquid + snippets/sp-cart-avis-properties
     .liquid). Diese Liquid-Dateien bleiben in diesem Ticket UNVERAENDERT;
     hier steht ausschliesslich der JavaScript-Port fuer das Modal, weil das
     Modal seine Werte nicht aus Liquid, sondern JS-seitig bezieht.

     ROOT CAUSE SP-800-041 (live am 2026-08-06 auf shirtplus.net verifiziert:
     Latzschuerze Colours PW150, zwei Logos, zwei echte AVIS-Datei-Uploads):

     Das Modal las die AVIS-Properties FLACH ueber fest verdrahtete
     Schluesselnamen aus, statt sie slotweise zu gruppieren:

     a) NUR EINE DATEI. Der Dateischluessel wurde mit einem Muster auf
        "datei hoch..." gesucht und dann mit .filter(...)[0] der ERSTE
        Treffer genommen (First-Match). Beide realen Schluessel
        "Datei hochalden-1-1" (Slot 1) und "Datei hochalden 2-1-1" (Slot 2)
        passen auf dieses Muster - Datei 2 war also im Datensatz vorhanden,
        wurde aber nie gelesen. Ausgegeben wurde eine einzige, keinem Logo
        zugeordnete Zeile "Hochgeladene Datei".

     b) LOGOBREITE VON LOGO 2 FEHLTE IMMER. Sie wurde unter dem Schluessel
        "Deine Bemerkung-2" gesucht. Diesen Schluessel gibt es nicht. AVIS
        liefert real "Deine Bemerkung-1" (Slot 1) und "Deine Bemerkung 1"
        (Slot 2, mit Leerzeichen, ohne Bindestrich).

     c) ZWEI VERSCHIEDENE LABELSYSTEME. Slot 1 wurde ueber generische Labels
        (Veredelung / Position / Logo-Groesse) ausgegeben, Slot 2 ueber
        ad-hoc zusammengesetzte Labels ("2. Logo – Veredelung" /
        "2. Logo – Position"). Es gab keine Ueberschrift und keine Trennung
        je Logo.

     d) HARTE BEGRENZUNG AUF ZWEI LOGOS. Die Ermittlung lief ueber zwei
        Einzelvariablen (finishing1/finishing2) und ueber die Schluessel der
        Aufpreis-Tabelle AVIS_CHARGE_MAP, die nur "1." und "2." kennt.
        Ein drittes Logo waere unsichtbar geblieben.

     e) INTRO-TEXT. Der Zusatzsatz wurde ausschliesslich aus Logo 1 gebildet
        und die Veredelungsart hart abgeleitet ("Stickveredelung"), immer im
        Singular. Bei zwei Logos stand daher "99 × Latzschuerzen wurden ...
        Die gewaehlte Stickveredelung wurde ..." - grammatikalisch falsch
        und inhaltlich falsch, weil Logo 2 real "Digitaldruck" war.

     LOESUNG: dieselbe belegte Indexstrategie wie SP-800-040 -
     Ordinalanker erkennen ("1. ", "2)") und alle uebrigen Properties dem
     ZULETZT GESEHENEN Anker zuordnen (Carry-Forward-Segmentierung entlang
     der echten AVIS-Property-Reihenfolge). Kein Index aus Array-/Karten-
     Position, kein First-Match, keine DOM-Reihenfolge, keine starren
     exakten Feldnamen als einzige Erkennung.
     ------------------------------------------------------------------------ */

  // Port von snippets/sp-avis-logo-index.liquid: nur ein echtes Ordinal-
  // praefix ("1. ", "2)") gilt als eindeutiger Logo-Index. Eine blosse
  // fuehrende Zahl ohne Ordinalzeichen ("5 cm Zugabe") wird bewusst NICHT
  // als Index gewertet, um Falschtreffer zu vermeiden.
  //   "1. Logo Position"        -> "1"
  //   "2. Logo auf Latzschuerzen" -> "2"
  //   "10. Logo Position"       -> "10"
  //   "1) Logo Position"        -> "1"
  //   "Deine Bemerkung-1"       -> ""  (kein Ordinalpraefix)
  //   "Datei hochalden 2-1-1"   -> ""  (kein Ordinalpraefix)
  //   "Groesse 1.5 cm"          -> ""  (Kopf "Groesse 1" ist nicht numerisch)
  function spAvisOrdinalIndex(key) {
    var src = String(key == null ? '' : key).trim();

    function head(sep) {
      var at = src.indexOf(sep);
      if (at === -1) return '';
      var part = src.slice(0, at).trim();
      if (!part) return '';
      // Entspricht der Liquid-Pruefung `plus: 0 | append: ''` == Kopf
      // unveraendert: akzeptiert "1"/"10", verwirft "01", "1a", "Groesse 1".
      if (!/^[0-9]+$/.test(part)) return '';
      if (String(parseInt(part, 10)) !== part) return '';
      return part;
    }

    return head('.') || head(')');
  }

  // Schwacher Bindestrich-Fallback (entspricht Liquid Pass 2b). Wird
  // ausschliesslich benutzt, wenn die GESAMTE Property-Liste keinen einzigen
  // Ordinalanker enthaelt, und kann die Segmentierung nie ueberstimmen.
  function spAvisWeakDashIndex(key) {
    var src = String(key == null ? '' : key);
    if (src.indexOf('-') === -1) return '';
    var parts = src.split('-');
    for (var i = 1; i < parts.length; i++) {
      var part = parts[i].trim();
      if (!part) continue;
      if (!/^[0-9]+$/.test(part)) continue;
      if (String(parseInt(part, 10)) !== part) continue;
      return part;
    }
    return '';
  }

  // Reihenfolgetreue Liste [{key, value}, ...] -> nach Logo-Slots gruppiert.
  // Ergebnis: [{index, finishing, position, width, files[], extras[]}, ...],
  // aufsteigend nach Logo-Index. Keine feste Obergrenze fuer die Anzahl.
  function spAvisLogoSlots(entries) {
    if (!entries || !entries.length) return [];

    var hasStrong = entries.some(function (e) { return !!spAvisOrdinalIndex(e.key); });

    var segment = '';
    var tagged = entries.map(function (e) {
      var strong = spAvisOrdinalIndex(e.key);
      if (strong) segment = strong;
      return {
        key: e.key,
        value: e.value,
        isAnchor: !!strong,
        index: hasStrong ? segment : spAvisWeakDashIndex(e.key)
      };
    });

    var order = [];
    var byIndex = {};

    tagged.forEach(function (t) {
      // Properties VOR dem ersten Anker sind keinem Slot eindeutig
      // zuordenbar (real betrifft das nur "_has_apo") und werden daher
      // keinem Logo-Block zugeschlagen - keine Fremddaten.
      if (!t.index) return;
      if (String(t.key).charAt(0) === '_') return;
      if (t.key === 'Gehört zu') return;
      if (t.value == null || String(t.value).trim() === '') return;

      if (!byIndex[t.index]) {
        byIndex[t.index] = {
          index: t.index,
          finishing: '',
          position: '',
          width: '',
          files: [],
          extras: []
        };
        order.push(t.index);
      }

      var slot = byIndex[t.index];
      var lower = String(t.key).toLowerCase();
      var value = String(t.value);

      // Die Reihenfolge dieser Pruefungen ist bewusst so gewaehlt, dass
      // "2. Logo Position" als POSITION des Slots 2 erkannt wird und NICHT
      // als eigener Veredelungsanker. Damit koennen die von AVIS erzeugten
      // Positionsaufpreis-Zeilen ("1. Logo Position"/"2. Logo Position")
      // niemals als zusaetzliches Logo missverstanden werden, und die
      // Position erscheint genau einmal pro Logo.
      if (value.indexOf('://') !== -1) {
        slot.files.push(value);
      } else if (lower.indexOf('position') !== -1) {
        if (!slot.position) slot.position = value;
      } else if (lower.indexOf('bemerkung') !== -1) {
        if (!slot.width) slot.width = value;
      } else if (t.isAnchor && !slot.finishing) {
        slot.finishing = value;
      } else {
        slot.extras.push({ key: t.key, value: value });
      }
    });

    order.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    return order.map(function (i) { return byIndex[i]; });
  }

  // Datenquelle-Priorisierung SP-800-041: ZUERST die Parent-Gruppe
  // bestimmen (stabile _sp_parent_id aus SP-800-027 plus _sp_role "main"),
  // erst DANN innerhalb dieser Gruppe den Logo-Slot. Gelesen werden die
  // echten /cart.js-Properties der Hauptzeile - also genau dieselbe Quelle
  // und dieselbe Reihenfolge, die auch die freigegebene Warenkorb-Ansicht
  // benutzt. Keine Zuordnung ueber DOM-Reihenfolge oder Zeilenposition.
  function avisEntriesFromCart(cart, parentId, addedKeys) {
    if (!cart || !cart.items || !parentId) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var li = cart.items[i];
      var props = li && li.properties;
      if (!props) continue;
      if (props['_sp_parent_id'] !== parentId) continue;
      if (props['_sp_role'] !== 'main') continue;
      if (addedKeys && addedKeys.length && addedKeys.indexOf(li.key) === -1) continue;
      return Object.keys(props).map(function (k) { return { key: k, value: props[k] }; });
    }
    return null;
  }

  // Sauberer Dateiname aus einer AVIS-Upload-URL: Fragment und
  // Query-Parameter entfernt, URL-decodiert, Bild/PDF unterschieden.
  function atcFileMeta(url) {
    var href = String(url || '');
    var bare = href.split('#')[0].split('?')[0];
    var raw = bare.split('/').pop() || '';
    var name = raw;
    try { name = decodeURIComponent(raw); } catch (e) {}
    var ext = (name.split('.').pop() || '').toLowerCase();
    var isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'avif'].indexOf(ext) !== -1;
    return {
      href: href,
      name: name || 'Datei',
      isImage: isImage,
      linkLabel: ext === 'pdf' ? 'Datei öffnen' : 'Vorschau anzeigen'
    };
  }

  // Einfuehrungstext: Menge, Produktbezeichnung und Veredelungsanzahl sind
  // dynamisch. Die VeredelungsART wird absichtlich NICHT genannt, weil auf
  // diesem Shop innerhalb EINER Konfiguration gemischte Arten moeglich sind
  // (live belegt: Logo 1 "Stick auf Latzschuerzen" + Logo 2 "Digitaldruck
  // auf Latzschuerzen"). Das Ticket gibt fuer genau diesen Fall die neutrale
  // Standardformulierung vor.
  function atcBuildSubline(quantity, titleSingular, titlePlural, logoCount) {
    var text;
    if (quantity === 1) {
      text = '1 × ' + (titleSingular || 'Artikel') +
        ' wurde erfolgreich in den Warenkorb übernommen.';
    } else {
      text = quantity + ' × ' + (titlePlural || titleSingular || 'Artikel') +
        ' wurden erfolgreich in den Warenkorb übernommen.';
    }
    if (logoCount === 1) {
      text += ' Die gewählte Veredelung wurde ebenfalls übernommen.';
    } else if (logoCount > 1) {
      text += ' Die gewählten Veredelungen wurden ebenfalls übernommen.';
    }
    return text;
  }

  var atcLastFocus = null;
  var atcKeydownHandler = null;
  var atcInertState = null;

  function atcFocusableEls(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      if (el.offsetParent === null) return false;
      var cs = window.getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') return false;
      if (el.hasAttribute('inert')) return false;
      return true;
    });
  }

  function atcForceFocusRing(el) {
    if (!el) return;
    el.classList.add('sp-atc-force-ring');
    el.addEventListener('blur', function onBlur() {
      el.classList.remove('sp-atc-force-ring');
      el.removeEventListener('blur', onBlur);
    });
  }

  function atcFocusOnOpen(overlay, target, modalEl) {
    overlay.classList.add('is-open');
    void overlay.offsetHeight;
    target.focus();
    atcForceFocusRing(target);
    if (document.activeElement !== target) {
      setTimeout(function () {
        var stillOpen = document.body.contains(overlay);
        if (!stillOpen) return;
        var fallbackTarget = document.body.contains(target) ? target : modalEl;
        fallbackTarget.focus();
        atcForceFocusRing(fallbackTarget);
      }, 0);
    }
  }

  function atcCleanupOverlay(overlay) {
    if (atcKeydownHandler) {
      document.removeEventListener('keydown', atcKeydownHandler);
      atcKeydownHandler = null;
    }
    atcRestoreBackgroundInert();
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  function atcSetBackgroundInert(overlay) {
    if (!('inert' in HTMLElement.prototype)) { atcInertState = []; return; }
    var state = [];
    Array.prototype.slice.call(document.body.children).forEach(function (el) {
      if (el === overlay) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK' || el.tagName === 'NOSCRIPT') return;
      var hadInert = el.hasAttribute('inert');
      state.push({ el: el, hadInert: hadInert });
      if (!hadInert) el.setAttribute('inert', '');
    });
    atcInertState = state;
  }

  function atcRestoreBackgroundInert() {
    if (!atcInertState) return;
    atcInertState.forEach(function (entry) {
      if (!entry.hadInert) entry.el.removeAttribute('inert');
    });
    atcInertState = null;
  }

  function atcIsFocusable(el) {
    if (!el || !document.contains(el)) return false;
    if (el === document.body) return false;
    if (typeof el.focus !== 'function') return false;
    if (el.disabled) return false;
    if (el.hasAttribute('inert')) return false;
    if (el.closest('[inert]')) return false;
    if (el.offsetParent === null) return false;
    var cs = window.getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    return true;
  }

  function atcRestoreFocus() {
    var target = null;
    if (atcIsFocusable(atcLastFocus)) {
      target = atcLastFocus;
    } else {
      var fallbackBtn = document.querySelector('[data-sp-pdp-add]:not([disabled])');
      if (atcIsFocusable(fallbackBtn)) {
        target = fallbackBtn;
      } else {
        var buybox = document.querySelector('.sp-pdp-buybox') || document.querySelector('[data-sp-pdp-product]');
        if (buybox) {
          if (!buybox.hasAttribute('tabindex')) buybox.setAttribute('tabindex', '-1');
          target = buybox;
        }
      }
    }
    if (target) {
      target.focus();
      atcForceFocusRing(target);
    }
  }

  function closeAddToCartModal() {
    var overlay = document.getElementById('sp-atc-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (atcKeydownHandler) { document.removeEventListener('keydown', atcKeydownHandler); atcKeydownHandler = null; }
    atcRestoreBackgroundInert();
    setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 220);
    atcRestoreFocus();
  }

  function atcRow(label, valueHtml) {
    if (valueHtml == null || valueHtml === '') return '';
    return '<div class="sp-atc-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd></div>';
  }

  // SP-800-041: ein Logo = ein klar abgegrenzter Block mit Ueberschrift
  // "N. Logo" und IMMER denselben einheitlichen Feldlabels
  // (Veredelung / Position / Logobreite / Logo-Datei). Es werden keine
  // Labels wie "2. Logo – Veredelung" mehr erzeugt.
  function atcLogoBlock(slot) {
    var rows = '';
    rows += atcRow('Veredelung', slot.finishing ? escapeHtml(slot.finishing) : '');
    rows += atcRow('Position', slot.position ? escapeHtml(slot.position) : '');
    rows += atcRow('Logobreite', slot.width ? escapeHtml(slot.width) : '');

    slot.extras.forEach(function (extra) {
      rows += atcRow(extra.key, escapeHtml(extra.value));
    });

    if (slot.files.length) {
      slot.files.forEach(function (url) {
        var file = atcFileMeta(url);
        var thumb = file.isImage
          ? '<img class="sp-atc-file__thumb" src="' + escapeHtml(file.href) + '" alt="" loading="lazy" data-atc-file-thumb>'
          : '';
        rows += atcRow('Logo-Datei',
          '<span class="sp-atc-file">' + thumb +
            '<span class="sp-atc-file__text">' +
              '<span class="sp-atc-file__name" title="' + escapeHtml(file.name) + '">' + escapeHtml(file.name) + '</span>' +
              '<a class="sp-atc-file-link" href="' + escapeHtml(file.href) + '" target="_blank" rel="noopener noreferrer">' +
                escapeHtml(file.linkLabel) +
              '</a>' +
            '</span>' +
          '</span>');
      });
    } else {
      // Fehlende Datei: NIE die Datei eines anderen Logos uebernehmen.
      rows += atcRow('Logo-Datei', '<span class="sp-atc-file-empty">Keine Datei hochgeladen</span>');
    }

    return '<section class="sp-atc-logo">' +
        '<h3 class="sp-atc-logo__title">' + escapeHtml(slot.index) + '. Logo</h3>' +
        '<dl class="sp-atc-details sp-atc-logo__details">' + rows + '</dl>' +
      '</section>';
  }

  function openAddToCartModal(payload) {
    var old = document.getElementById('sp-atc-overlay');
    if (old) atcCleanupOverlay(old);

    var subline = payload.subline || '';

    var rowsHtml = (payload.rows || []).map(function (r) { return atcRow(r.label, r.value); }).join('');

    var logoSlots = payload.logoSlots || [];
    var logoBlocksHtml = '';
    if (logoSlots.length) {
      logoBlocksHtml =
        '<hr class="sp-atc-divider">' +
        '<div class="sp-atc-logos">' + logoSlots.map(atcLogoBlock).join('') + '</div>';
    }

    var discountRowHtml = '';
    if (payload.discount) {
      discountRowHtml =
        '<div class="sp-atc-price-row sp-atc-price-row--discount"><span>Rabatt</span><span>' + escapeHtml(payload.discount) + '</span></div>';
    }

    var imageHtml = payload.image
      ? '<img src="' + escapeHtml(payload.image) + '" alt="" loading="lazy">'
      : '';

    var titleId = 'sp-atc-title-' + Date.now();
    var sublineId = 'sp-atc-subline-' + Date.now();

    var overlay = document.createElement('div');
    overlay.id = 'sp-atc-overlay';
    overlay.className = 'sp-atc-overlay';
    overlay.innerHTML =
      '<div class="sp-atc-modal" role="dialog" aria-modal="true" aria-labelledby="' + titleId + '" aria-describedby="' + sublineId + '" tabindex="-1">' +
        '<button type="button" class="sp-atc-close" data-atc-close aria-label="Dialog schließen">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="sp-atc-body">' +
          '<div class="sp-atc-success">' +
            '<span class="sp-atc-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span>' +
            '<h2 class="sp-atc-title" id="' + titleId + '">Zum Warenkorb hinzugefügt</h2>' +
            '<p class="sp-atc-subline" id="' + sublineId + '">' + escapeHtml(subline) + '</p>' +
          '</div>' +
          '<hr class="sp-atc-divider">' +
          '<div class="sp-atc-product">' +
            '<div class="sp-atc-product__image">' + imageHtml + '</div>' +
            '<dl class="sp-atc-details">' + rowsHtml + '</dl>' +
          '</div>' +
          logoBlocksHtml +
          '<hr class="sp-atc-divider">' +
          '<div class="sp-atc-price">' +
            '<div class="sp-atc-price-row"><span>Zwischensumme</span><span>' + escapeHtml(payload.subtotal) + '</span></div>' +
            discountRowHtml +
            '<div class="sp-atc-total"><span>Gesamt</span><span>' + escapeHtml(payload.total) + '</span></div>' +
          '</div>' +
        '</div>' +
        '<div class="sp-atc-actions">' +
          '<div class="sp-atc-actions__row">' +
            '<a class="sp-pdp-btn sp-pdp-btn--mint" href="' + root() + 'cart" data-atc-view-cart>Warenkorb ansehen</a>' +
            '<button type="button" class="sp-pdp-btn sp-pdp-btn--secondary" data-atc-continue>Weiter einkaufen</button>' +
          '</div>' +
          '<a class="sp-atc-checkout-link" href="' + root() + 'checkout" data-atc-checkout>Direkt zur Kasse →</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    atcSetBackgroundInert(overlay);

    // Defensive: sollte eine AVIS-Datei-URL nicht als Bild darstellbar sein,
    // wird die Miniatur entfernt statt ein kaputtes Bild zu zeigen. Der
    // Dateiname und der Link bleiben in jedem Fall erhalten.
    Array.prototype.slice.call(overlay.querySelectorAll('[data-atc-file-thumb]')).forEach(function (img) {
      img.addEventListener('error', function () {
        if (img.parentNode) img.parentNode.removeChild(img);
      });
    });

    var modalEl = overlay.querySelector('.sp-atc-modal');
    var closeBtn = overlay.querySelector('[data-atc-close]');

    atcFocusOnOpen(overlay, closeBtn || modalEl, modalEl);

    overlay.querySelector('[data-atc-close]').addEventListener('click', closeAddToCartModal);
    overlay.querySelector('[data-atc-continue]').addEventListener('click', closeAddToCartModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeAddToCartModal(); });

    atcKeydownHandler = function (e) {
      if (e.key === 'Escape') { closeAddToCartModal(); return; }
      if (e.key !== 'Tab') return;
      var focusable = atcFocusableEls(modalEl);
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (!modalEl.contains(active)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', atcKeydownHandler);
  }

  var SpPdpProduct = function () {};

  function initProduct(rootEl) {
    var dataScript = rootEl.querySelector('[data-sp-pdp-data]');
    if (!dataScript) return;

    var data;
    try { data = JSON.parse(dataScript.textContent); }
    catch (e) { console.error('[sp-pdp] invalid data json', e); return; }

    var state = {
      brandingFile: null,
      uploading: false,
      lastParentId: null
    };

    var cells      = Array.prototype.slice.call(rootEl.querySelectorAll('[data-sp-pdp-cell]'));
    var stageImg   = rootEl.querySelector('[data-sp-pdp-stage-img]');
    var thumbs     = Array.prototype.slice.call(rootEl.querySelectorAll('[data-sp-pdp-thumb]'));
    var totalEl    = rootEl.querySelector('[data-sp-pdp-total]');
    var qtyEl      = rootEl.querySelector('[data-sp-pdp-total-qty]');
    var rowTotals  = {};
    Array.prototype.slice.call(rootEl.querySelectorAll('[data-sp-pdp-rowtotal]')).forEach(function (el) {
      rowTotals[el.getAttribute('data-sp-pdp-rowtotal')] = el;
    });
    var addBtns    = Array.prototype.slice.call(document.querySelectorAll('[data-sp-pdp-add="' + rootEl.id + '"], [data-sp-pdp-add]'))
                       .filter(function (b) {
                         var t = b.getAttribute('data-sp-pdp-add');
                         return t === '' || t === rootEl.id || rootEl.contains(b);
                       });
    var tiers      = Array.prototype.slice.call(document.querySelectorAll('[data-sp-pdp-tier]'));

    cells.forEach(function (cell) {
      var input = cell.querySelector('input');
      var dec = cell.querySelector('[data-sp-pdp-dec]');
      var inc = cell.querySelector('[data-sp-pdp-inc]');

      function setVal(n) {
        n = Math.max(0, Math.min(9999, parseInt(n, 10) || 0));
        input.value = n;
        recalc();
      }
      if (dec) { dec.setAttribute('tabindex', '-1'); dec.addEventListener('click', function () { setVal((parseInt(input.value, 10) || 0) - 1); }); }
      if (inc) { inc.setAttribute('tabindex', '-1'); inc.addEventListener('click', function () { setVal((parseInt(input.value, 10) || 0) + 1); }); }
      if (input) {
        input.addEventListener('input', function () { setVal(input.value); });
        input.addEventListener('blur', function () { if (input.value === '') setVal(0); });
      }
    });

    function recalc() {
      var totalCents = 0, totalQty = 0, perColor = {};
      cells.forEach(function (cell) {
        var input = cell.querySelector('input');
        var qty = parseInt(input && input.value, 10) || 0;
        var price = parseInt(cell.getAttribute('data-price'), 10) || 0;
        var color = cell.getAttribute('data-color') || '';
        if (qty > 0) {
          totalCents += qty * price;
          totalQty += qty;
          perColor[color] = (perColor[color] || 0) + qty;
        }
      });

      Object.keys(rowTotals).forEach(function (c) { rowTotals[c].textContent = perColor[c] || 0; });
      if (totalEl) totalEl.textContent = formatMoney(totalCents);
      if (qtyEl) qtyEl.textContent = totalQty;

      var bestTier = null;
      tiers.forEach(function (t) {
        var minQty = t.getAttribute('data-min-qty');
        if (minQty !== null) {
          if (totalQty >= (parseInt(minQty, 10) || 0)) bestTier = t;
        } else {
          if (totalCents >= (parseInt(t.getAttribute('data-min'), 10) || 0)) bestTier = t;
        }
      });
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === bestTier); });

      // SP-2026-09-17: Der Warenkorb-Button bleibt klickbar, solange noch keine Menge gewaehlt
      // ist - der Klick fuehrt dann zur Groessentabelle (siehe addToCart). Hart gesperrt wird nur
      // waehrend eines laufenden Uploads oder waehrend des Absendens.
      addBtns.forEach(function (b) {
        if (b.dataset.loading === 'true') return;
        b.disabled = state.uploading === true;
        b.classList.toggle('sp-pdp-btn--idle', totalQty === 0);
        b.setAttribute('aria-disabled', totalQty === 0 ? 'true' : 'false');
      });
      return { totalCents: totalCents, totalQty: totalQty };
    }

    function collectAvisProps() {
      var props = {};
      var count = 0;
      document.querySelectorAll('.avis-input-hiddens input[name^="properties["], .sp-pdp-avis-anchor-form input[name^="properties["]')
        .forEach(function (inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (m && inp.value) { props[m[1]] = inp.value; count++; }
        });
      return count ? props : null;
    }

    // SP-800-041: dieselben Hidden-Inputs, aber REIHENFOLGETREU als Liste.
    // Die Segmentierung an den Ordinal-Ankern braucht die tatsaechliche
    // Ausgabereihenfolge von AVIS. AVIS rendert den Hidden-Satz auf dieser
    // Installation mehrfach (leerer Vorlagensatz + gefuellter Satz); daher
    // wird pro Schluessel die Position der ERSTEN Nennung beibehalten und
    // der Wert der LETZTEN nicht-leeren Nennung uebernommen - identische
    // Wertsemantik wie collectAvisProps() oben.
    function collectAvisPropsOrdered() {
      var order = [];
      var map = {};
      document.querySelectorAll('.avis-input-hiddens input[name^="properties["], .sp-pdp-avis-anchor-form input[name^="properties["]')
        .forEach(function (inp) {
          var m = inp.name.match(/^properties\[(.+)\]$/);
          if (!m || !inp.value) return;
          var key = m[1];
          if (!Object.prototype.hasOwnProperty.call(map, key)) order.push(key);
          map[key] = inp.value;
        });
      return order.map(function (key) { return { key: key, value: map[key] }; });
    }

    var AVIS_CHARGE_MAP = {
      '1. Logo T-Shirts hinzufügen':     { 'Digitaldruck': 55865442468166, 'Stick': 55865442500934 },
      '1. Logo Position (Digitaldruck)': { 'Schulterblatt': 55865442599238, 'Rücken komplett': 55865442632006 },
      '2. Logo T-Shirts hinzufügen':     { 'Digitaldruck': 55865442730310, 'Stick': 55865442763078 },
      '2. Logo Position (Digitaldruck)': { 'Schulterblatt': 55865442861382, 'Rücken komplett': 55865442894150 },

      '1. Logo auf Latzschürzen': { 'Digitaldruck auf Latzschürzen': 55493007442246, 'Stick auf Latzschürzen': 55493007475014 },
      '2. Logo auf Latzschürzen': { 'Digitaldruck auf Latzschürzen': 55493007573318, 'Stick auf Latzschürzen': 55493007606086 },
      '1. Logo Position':         { 'Oben gross': 54822887686470, 'Oben komplett': 54822887719238 },
      '2. Logo Position':         { 'Oben gross': 54822909542726, 'Oben komplett': 54822909575494 }
    };

    function atcGenParentId() {
      return 'sp' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // SP-800-027 Nachbesserung: Live festgestellt, dass die AvisPlus-App auf
    // JEDER Produktseite dieses Themes (ausnahmslos, auch bei Produkten ganz
    // ohne tatsaechliche Logo-/Stick-Auswahl) ein statisches verstecktes Feld
    // properties[_has_apo] = "true" vorrendert - unabhaengig davon, ob der
    // Kunde jemals eine Veredelungsoption geoeffnet oder ausgewaehlt hat.
    // collectAvisProps() liefert daher bei JEDEM Produkt ein nicht-leeres
    // Objekt zurueck, sobald nur dieses eine Boilerplate-Feld vorhanden ist.
    // Ein naiver "if (avisProps)"-Check wuerde deshalb JEDEM Warenkorb-Eintrag
    // auf der gesamten Seite eine _sp_parent_id zuweisen und damit das native
    // Zusammenfassen gleicher Varianten fuer ALLE Produkte verhindern - genau
    // die in Ticket Abschnitt 8 ausgeschlossene Regression fuer normale
    // Produkte ohne AVIS. Fix: nur dann eine Parent-Kennung vergeben, wenn
    // mindestens ein Schluessel aus avisProps tatsaechlich in AVIS_CHARGE_MAP
    // vorkommt (also eine echte Veredelungsauswahl mit Wert vorliegt) - das
    // rein informative _has_apo-Flag zaehlt dafuer nicht.
    function hasRealAvisSelection(props) {
      if (!props) return false;
      return Object.keys(props).some(function (k) {
        return Object.prototype.hasOwnProperty.call(AVIS_CHARGE_MAP, k) && props[k];
      });
    }

    function collectAvisCharges(props, totalQty, spParentId) {
      var charges = [];
      if (!props || totalQty <= 0) return charges;
      var parentTitle = (data && data.title) || 'Hauptprodukt';
      Object.keys(props).forEach(function (key) {
        var map = AVIS_CHARGE_MAP[key];
        if (!map) return;
        var val = String(props[key]);
        Object.keys(map).forEach(function (prefix) {
          if (val.indexOf(prefix) === 0) {
            var chargeProps = { 'Gehört zu': parentTitle };
            if (spParentId) {
              chargeProps['_sp_parent_id'] = spParentId;
              chargeProps['_sp_role'] = 'charge';
            }
            charges.push({ id: map[prefix], quantity: totalQty, properties: chargeProps });
          }
        });
      });
      return charges;
    }

    function collectItems() {
      var items = [];
      var avisProps = collectAvisProps();
      var props = avisProps ? Object.assign({}, avisProps) : {};
      if (state.brandingFile) {
        props['Design-Datei'] = state.brandingFile.name;
        if (state.brandingFile.url) props['Design-Datei (URL)'] = state.brandingFile.url;
      }
      var spParentId = null;
      if (hasRealAvisSelection(avisProps)) {
        spParentId = atcGenParentId();
        props['_sp_parent_id'] = spParentId;
        props['_sp_role'] = 'main';
      }
      // SP-800-041: Parent-Kennung merken, damit das Modal danach die
      // richtige Hauptzeile in /cart.js finden kann (Parent-Gruppe zuerst).
      state.lastParentId = spParentId;
      var hasProps = Object.keys(props).length > 0;
      var totalQty = 0;
      cells.forEach(function (cell) {
        var input = cell.querySelector('input');
        var qty = parseInt(input && input.value, 10) || 0;
        var id = cell.getAttribute('data-variant');
        if (qty > 0 && id) {
          var item = { id: parseInt(id, 10), quantity: qty };
          if (hasProps) item.properties = props;
          items.push(item);
          totalQty += qty;
        }
      });
      if (items.length) {
        collectAvisCharges(avisProps, totalQty, spParentId).forEach(function (c) { items.push(c); });
      }
      return items;
    }

    function buildAtcPayload(ctx) {
      var mainSnapshot = ctx.mainSnapshot;
      var mainQty = mainSnapshot.reduce(function (s, c) { return s + c.qty; }, 0);
      var logoSlots = ctx.logoSlots || [];

      // SP-800-041 PRODUKT-STAMMDATEN: genau EINMAL oberhalb der Logo-
      // Bloecke. Produktname, Farbe, Groesse und Gesamtmenge werden NICHT
      // pro Logo wiederholt. Veredelung, Position, Logobreite und
      // Logo-Datei stehen ausschliesslich im jeweiligen Logo-Block
      // (frueher standen sie flach in dieser Liste).
      var rows = [];
      rows.push({ label: 'Produkt', value: escapeHtml(data.title || '') });

      var colors = mainSnapshot.map(function (c) { return c.color; }).filter(Boolean);
      var uniqColors = colors.filter(function (c, i) { return colors.indexOf(c) === i; });
      if (uniqColors.length === 1) rows.push({ label: 'Farbe', value: escapeHtml(uniqColors[0]) });

      var sizes = mainSnapshot.map(function (c) { return c.size; }).filter(Boolean);
      var uniqSizes = sizes.filter(function (s, i) { return sizes.indexOf(s) === i; });
      if (uniqSizes.length === 1) rows.push({ label: 'Größe', value: escapeHtml(uniqSizes[0]) });

      rows.push({ label: 'Menge', value: String(mainQty) });

      var subtotalCents = ctx.subtotalCents || 0;
      var discountCents = ctx.discountCents || 0;
      var totalCents = ctx.totalCents != null ? ctx.totalCents : subtotalCents;

      return {
        title: data.title || '',
        image: ctx.image || '',
        quantity: mainQty,
        productTypePlural: data.productType || '',
        subline: atcBuildSubline(mainQty, data.title || '', data.productType || '', logoSlots.length),
        rows: rows,
        logoSlots: logoSlots,
        subtotal: formatMoney(subtotalCents),
        discount: discountCents > 0 ? ('−' + formatMoney(discountCents)) : '',
        total: formatMoney(totalCents)
      };
    }

    function addToCart() {
      atcLastFocus = document.activeElement;

      if (state.uploading) { toast('Deine Datei wird noch hochgeladen …', true); return; }
      var items = collectItems();
      if (!items.length) {
        // SP-2026-09-17: statt stumm zu blockieren zur Groessentabelle fuehren
        var firstQty = rootEl.querySelector('[data-sp-pdp-cell] input');
        if (firstQty) {
          var box = firstQty.closest('[data-sp-pdp-matrix]') || firstQty.closest('table') || firstQty;
          try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
          setTimeout(function () { try { firstQty.focus({ preventScroll: true }); } catch (e) {} }, 400);
        }
        toast('Bitte wähle zuerst Größen und Mengen.', true);
        return;
      }

      addBtns.forEach(function (b) { b.disabled = true; b.dataset.loading = 'true'; });

      var avisProps = collectAvisProps();
      // SP-800-041: reihenfolgetreue Fassung als Fallback-Datenquelle und
      // die Parent-Kennung der gerade zusammengestellten Gruppe.
      var avisPropsOrdered = collectAvisPropsOrdered();
      var spParentId = state.lastParentId;

      var mainSnapshot = [];
      cells.forEach(function (cell) {
        var input = cell.querySelector('input');
        var qty = parseInt(input && input.value, 10) || 0;
        if (qty > 0) {
          mainSnapshot.push({
            variantId: parseInt(cell.getAttribute('data-variant'), 10),
            color: cell.getAttribute('data-color') || '',
            size: cell.getAttribute('data-size') || '',
            qty: qty
          });
        }
      });
      var mainVariantIds = mainSnapshot.map(function (c) { return c.variantId; });
      var modalImage = stageImg ? (stageImg.currentSrc || stageImg.src || '') : '';

      var sendItems = items.slice().reverse();
      var roles = sendItems.map(function (it) {
        return mainVariantIds.indexOf(it.id) !== -1 ? 'main' : 'charge';
      });

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: sendItems })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            toast(res.body && res.body.description ? res.body.description : 'Hinzufügen fehlgeschlagen.', true);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { blockCartDrawerOpening: true } }));

          var respItems = (res.body && res.body.items) || [];
          var addedKeys = [];
          respItems.forEach(function (ri) { if (ri && ri.key) addedKeys.push(ri.key); });

          function showModalWithCart(cartAfter) {
            var subtotalCents = 0, discountCents = 0, matched = false;
            if (cartAfter && cartAfter.items) {
              cartAfter.items.forEach(function (li) {
                if (addedKeys.indexOf(li.key) === -1) return;
                matched = true;
                subtotalCents += li.original_line_price || 0;
                discountCents += li.total_discount || 0;
              });
            }
            if (!matched) {
              respItems.forEach(function (ri) {
                subtotalCents += (ri.original_line_price != null ? ri.original_line_price : ri.line_price) || 0;
              });
              discountCents = 0;
            }
            var totalCents = subtotalCents - discountCents;

            // SP-800-041 SLOT-ZUORDNUNG: zuerst die Parent-Gruppe in den
            // echten /cart.js-Daten bestimmen, dann innerhalb dieser Gruppe
            // die Logo-Slots per Ordinalanker-Segmentierung. Faellt der
            // /cart.js-Abruf aus, dienen die reihenfolgetreuen
            // AVIS-Hidden-Inputs als Fallback.
            var slotEntries = avisEntriesFromCart(cartAfter, spParentId, addedKeys) || avisPropsOrdered;
            var logoSlots = spAvisLogoSlots(slotEntries);

            var payload = buildAtcPayload({
              mainSnapshot: mainSnapshot,
              avisProps: avisProps,
              logoSlots: logoSlots,
              image: modalImage,
              subtotalCents: subtotalCents,
              discountCents: discountCents,
              totalCents: totalCents
            });
            openAddToCartModal(payload);
          }

          fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(showModalWithCart)
            .catch(function () { showModalWithCart(null); });

          cells.forEach(function (cell) { var i = cell.querySelector('input'); if (i) i.value = '0'; });
          recalc();
        })
        .catch(function () { toast('Netzwerkfehler. Bitte erneut versuchen.', true); })
        .finally(function () {
          addBtns.forEach(function (b) { delete b.dataset.loading; });
          recalc();
        });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (stageImg) {
          stageImg.src = t.getAttribute('data-src');
          stageImg.removeAttribute('srcset');
          stageImg.removeAttribute('sizes');
          stageImg.alt = t.getAttribute('data-alt') || '';
        }
      });
    });

    addBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    var upload = rootEl.querySelector('[data-sp-pdp-upload]');
    if (upload) initUpload(upload, {
      onChange: function (file) { state.brandingFile = file; },
      onUploading: function (busy) { state.uploading = busy; recalc(); }
    });

    recalc();
  }

  function initUpload(wrap, handlers) {
    var input    = wrap.querySelector('input[type="file"]');
    var nameEl   = wrap.querySelector('[data-sp-pdp-upload-name]');
    var statusEl = wrap.querySelector('[data-sp-pdp-upload-status]');
    var progress = wrap.querySelector('[data-sp-pdp-upload-progress]');
    var bar      = wrap.querySelector('[data-sp-pdp-upload-bar]');
    var drop     = wrap.querySelector('[data-sp-pdp-upload-drop]') || wrap;
    if (!input) return;

    var uploadUrl = (wrap.getAttribute('data-upload-url') || '').trim();
    var MAX = 20 * 1024 * 1024;
    var OK = ['image/jpeg', 'image/png', 'application/pdf', 'application/postscript',
              'application/illustrator', 'image/vnd.adobe.photoshop'];
    var OK_EXT = ['jpg', 'jpeg', 'png', 'pdf', 'ai'];

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.style.display = msg ? 'block' : 'none';
      statusEl.classList.toggle('is-error', kind === 'error');
      statusEl.classList.toggle('is-ok', kind === 'ok');
    }
    function showProgress(show, pct) {
      if (progress) { progress.hidden = !show; }
      if (bar) { bar.style.width = (pct || 0) + '%'; }
    }

    function validate(file) {
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      if (OK.indexOf(file.type) === -1 && OK_EXT.indexOf(ext) === -1) {
        toast('Dateiformat nicht unterstützt (JPG, PNG, PDF, AI).', true); return false;
      }
      if (file.size > MAX) { toast('Datei zu groß (max. 20 MB).', true); return false; }
      return true;
    }

    function handle(file) {
      if (!file || !validate(file)) return;

      wrap.classList.add('has-file');
      if (nameEl) nameEl.textContent = file.name;

      if (!uploadUrl) {
        setStatus('Datei vorgemerkt – wird mit deiner Anfrage übermittelt.', 'ok');
        handlers.onChange({ name: file.name, size: file.size, url: null });
        return;
      }

      wrap.classList.add('is-uploading');
      handlers.onUploading(true);
      setStatus('Wird hochgeladen …');
      showProgress(true, 0);

      var form = new FormData();
      form.append('file', file, file.name);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', uploadUrl, true);
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) showProgress(true, Math.round((e.loaded / e.total) * 100));
      };
      xhr.onload = function () {
        wrap.classList.remove('is-uploading');
        handlers.onUploading(false);
        showProgress(false, 100);
        var data = {};
        try { data = JSON.parse(xhr.responseText || '{}'); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && data.url) {
          setStatus('Hochgeladen ✓', 'ok');
          handlers.onChange({ name: file.name, size: file.size, url: data.url });
        } else {
          setStatus('Upload fehlgeschlagen – Datei wird mit der Anfrage übermittelt.', 'error');
          handlers.onChange({ name: file.name, size: file.size, url: null });
        }
      };
      xhr.onerror = function () {
        wrap.classList.remove('is-uploading');
        handlers.onUploading(false);
        showProgress(false, 0);
        setStatus('Netzwerkfehler beim Upload – Datei wird mit der Anfrage übermittelt.', 'error');
        handlers.onChange({ name: file.name, size: file.size, url: null });
      };
      xhr.send(form);
    }

    input.addEventListener('change', function () { handle(input.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.add('is-dragover'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.remove('is-dragover'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files[0]) handle(e.dataTransfer.files[0]);
    });
  }

  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-sp-pdp-accordion]').forEach(function (acc) {
      var single = acc.hasAttribute('data-single');
      acc.querySelectorAll('.sp-pdp-acc-item').forEach(function (item) {
        var trigger = item.querySelector('.sp-pdp-acc-trigger');
        var panel = item.querySelector('.sp-pdp-acc-panel');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var open = item.getAttribute('aria-expanded') === 'true';
          if (single && !open) {
            acc.querySelectorAll('.sp-pdp-acc-item[aria-expanded="true"]').forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');
              other.querySelector('.sp-pdp-acc-panel').style.height = '0px';
            });
          }
          item.setAttribute('aria-expanded', String(!open));
          panel.style.height = open ? '0px' : panel.firstElementChild.scrollHeight + 'px';
        });
      });
    });
  }

  var lastFocus = null;
  function openModal(modal) {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('.sp-pdp-modal__close');
    if (close) close.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }
  function initModals(scope) {
    (scope || document).querySelectorAll('[data-sp-pdp-modal-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(document.getElementById(trigger.getAttribute('data-sp-pdp-modal-open')));
      });
    });
    (scope || document).querySelectorAll('.sp-pdp-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-sp-pdp-modal-close], .sp-pdp-modal__backdrop, .sp-pdp-modal__close')
        .forEach(function (el) { el.addEventListener('click', function () { closeModal(modal); }); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.sp-pdp-modal.is-open').forEach(closeModal);
    });
  }

  function findAvisTrigger(custom) {
    var sels = [];
    if (custom) sels.push(custom);
    sels = sels.concat([
      '.avpoptions-popup-btn', '.avpoptions-popup-button', '.avpoptions-modal-trigger',
      'button[class*="avpoptions"]', '[class*="avpoptions"] button',
      'button[class*="avisplus"]', '[class*="avisplus"] button',
      '[class*="avpoptions-container"] [role="button"]'
    ]);
    for (var i = 0; i < sels.length; i++) {
      try {
        var el = document.querySelector(sels[i]);
        if (el && !el.hasAttribute('data-sp-pdp-avis-open')) return el;
      } catch (e) {}
    }
    return null;
  }
  function initAvisOpener(scope) {
    (scope || document).querySelectorAll('[data-sp-pdp-avis-open]').forEach(function (btn) {
      if (btn.dataset.spAvisBound) return;
      btn.dataset.spAvisBound = '1';
      btn.addEventListener('click', function () {
        var custom = btn.getAttribute('data-avis-selector');
        var el = findAvisTrigger(custom);
        if (el) { el.click(); return; }
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          var t = findAvisTrigger(custom);
          if (t) { clearInterval(iv); t.click(); }
          else if (tries >= 20) { clearInterval(iv); toast('Designer wird noch geladen – bitte erneut klicken.', true); }
        }, 150);
      });
    });
  }

  // SP-2026-09-17: Label der Logo-Buttons spiegelt den Stand des Konfigurators
  function avisConfigured() {
    var inputs = document.querySelectorAll('.avis-input-hiddens input[name^="properties["], .sp-pdp-avis-anchor-form input[name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      var n = inputs[i].name || '';
      if (n.indexOf('properties[_') === 0) continue;
      if (String(inputs[i].value || '').trim()) return true;
    }
    return false;
  }
  function syncAvisButtons() {
    var done = avisConfigured();
    document.querySelectorAll('[data-sp-pdp-avis-open]').forEach(function (b) {
      if (!b.dataset.spLabelAdd) b.dataset.spLabelAdd = b.textContent.trim();
      var label = done ? (b.getAttribute('data-label-done') || '\u2713 Logo ändern') : b.dataset.spLabelAdd;
      if (b.textContent.trim() !== label) b.textContent = label;
      b.classList.toggle('sp-pdp-btn--done', done);
    });
  }
  function initAvisWatch() {
    if (window.__spAvisWatch) return;
    window.__spAvisWatch = true;
    var t;
    function ping() { clearTimeout(t); t = setTimeout(syncAvisButtons, 250); }
    try {
      new MutationObserver(ping).observe(document.documentElement, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['value']
      });
    } catch (e) {}
    document.addEventListener('change', ping, true);
    // Aris setzt die versteckten Felder per JS-Property (kein change-Event, keine Attribut-
    // Aenderung) - deshalb zusaetzlich nach Klicks im Popup und in ruhigem Takt nachsehen.
    document.addEventListener('click', ping, true);
    setInterval(syncAvisButtons, 1500);
    syncAvisButtons();
  }
  function injectStateCss() {
    if (document.getElementById('sp-pdp-state-css')) return;
    var st = document.createElement('style');
    st.id = 'sp-pdp-state-css';
    st.textContent = '.sp-pdp-btn--idle{opacity:.55}.sp-pdp-btn--idle:hover{opacity:.72}'
      + '@media (max-width:699px){.sp-pdp-toast{bottom:104px}}';
    document.head.appendChild(st);
  }

  function boot() {
    document.querySelectorAll('[data-sp-pdp-product]').forEach(initProduct);
    initAccordions(document);
    initModals(document);
    initAvisOpener(document);
    injectStateCss();
    initAvisWatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target;
    sec.querySelectorAll('[data-sp-pdp-product]').forEach(initProduct);
    initAccordions(sec);
    initModals(sec);
    initAvisOpener(sec);
  });
})();
